import { useEffect, useState } from "react";

import { AiLogo } from "@/components/ai-logo/AiLogo";

import type { AiLogoState } from "@/components/ai-logo/AiLogo";

const TYPING_DEBOUNCE_MS = 1500;

export function ChatInputAiLogo({ isFocused }: { isFocused: boolean }) {
  const [isTyping, setIsTyping] = useState(false);

  useEffect(() => {
    if (!isFocused) {
      setIsTyping(false);
      return;
    }

    let timer: number | undefined;
    const onKeyDown = () => {
      setIsTyping(true);
      window.clearTimeout(timer);
      timer = window.setTimeout(() => setIsTyping(false), TYPING_DEBOUNCE_MS);
    };

    document.addEventListener("keydown", onKeyDown, true);

    return () => {
      document.removeEventListener("keydown", onKeyDown, true);
      window.clearTimeout(timer);
    };
  }, [isFocused]);

  let state: AiLogoState = "idle";
  if (isFocused) state = isTyping ? "typing" : "focus";

  return <AiLogo state={state} />;
}
